<template>
  <div>
    <div v-if="displayStyle === 'select'" >
      <Select @on-change="change" label-in-value clearable ref="selector">
        <Option :value="item.value" v-for="(item, index) in options" :key="index">
          {{item.label}}
        </Option>
      </Select>
    </div>
    <div v-else-if="displayStyle === 'button'">
      <ButtonGroup>
        <Button v-for="(item, index) in options" :type="selected && selected.value === item.value ? 'primary':'default'"
                @click="change(item)" :key="index">{{item.label}}
        </Button>
      </ButtonGroup>
    </div>
    <div v-else>
      <!-- Radio 还没来得及写 -->
    </div>
  </div>
</template>
<script>
  import {dict} from '@/libs'
  import lodash from 'lodash'

  /**
   * 控件说明
   *
   * 将传入的数据转换成标准的[{value: '', label: ''},...]对象数组, 并且进行显示
   * 用户选择后, 控件内的selected会变化, 用户可以通过<SelectPro ref="mySelect">, this.$refs.mySelect.selected来获取当前选项
   * 同时选择变化时, on-change会被调用, 父组件可以通过这个获取响应
   *
   */
  export default {
    props: {
      /**
       * optionData类型说明:
       *  String: 词典格式, 值为词典的名称
       *  Array: [{value:'',label:''}] || ['value','value']格式, 后一种默认label=value
       *  Object: 对象格式{param:data}, param = value, data = label
       */
      optionData: {type: [String, Array, Object], required: true},

      /**
       * 展示的方式 select, radio, button
       */
      displayStyle: {type: String, default: 'select'},

      /**
       * 灰色的选项, 只显示不可选, 根据value来确定
       */
      optionInGray: {type: Array},

      /**
       * 选中的值
       */
      valueSelected: null,
    },
    data() {
      return {
        options: [],    // 转换后的选择数据数组
        selected: null, // 选中的数据
      }
    },
    watch: {
      optionData() {
        this.initData(null) // 如果data发生改变, 重新生成选项数据
      },
      valueSelected(v) {
        console.log("on watch valueSelected")
        if (this.v!==null) {
          this.options.map(item => {
            if (item.value === v)
              this.selected = item
          })
        } else {
          this.selected = null
          if (this.$refs.selector)
            this.$refs.selector.clearSingleSelect();
        }
      }
    },
    methods: {
      change(item) {
        console.log("on change", item)
        this.selected = item
        this.$emit('on-change', item)
      },

      initData(v) {
        if (typeof this.optionData === 'string') {
          console.log("optionData is string, dict=", this.optionData)

          dict.dict(this.optionData).then(payload => {
            this.options = lodash.sortBy(
              Object.keys(payload.content).map(o => {
                return {value: o, label: payload.content[o]}
              }),
              item => item.value
            )
          })
        } else if (this.optionData instanceof Array) {
          console.log("optionData is Array")

          this.options = this.optionData.map(o => {
            return {value: o.value, label: o.label}
          })
        } else if (this.optionData instanceof Object) {
          console.log("optionData is Object")

          this.options = lodash.sortBy(
            Object.keys(this.optionData).map(o => {
              return {value: o, label: this.optionData[o]}
            }),
            item => item.value
          )
        } else {
          console.error("SelectPro传入的data数据错误, optionData=", this.optionData)
          this.options = []
        }

        if (v!==null) {
          this.options.map(item => {
            if (item.value === v)
              this.selected = item
          })
        } else {
          this.selected = null
          if (this.$refs.selector)
            this.$refs.selector.clearSingleSelect();
        }
      }
    },
    created() {
      this.initData(this.valueSelected)
    }
  }
</script>
